<template>
  <v-container fluid>
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="2"
        class="pt-1"
      >
        <inventory-class-select-element
          v-model="inventoryClassId"
          :hide-details="true"
          :is-inst="false"
          :is-glass="false"
          :is-vwd-glass="false"
          :is-panels="false"
          :is-state="true"
          :is-parts="false"
          :is-sid="false"
          :is-rail-part="false"
          :is-equipment="false"
          :is-railings="false"
          :is-paint="false"
          :is-patio-door="false"
          :is-euro-door="false"
          :is-medical-aid="false"
        />
      </v-col>

      <v-col
        v-if="windowWidth > 1500"
        class="pt-1 pr-0"
        cols="2"
      >
        <v-autocomplete
          v-model="filterJob"
          label="Job"
          :items="jobs"
          hide-details="true"
          :item-text="item => `${item.code} - ${item.name}; ${item.reference}`"
          item-value="id"
          clearable
          :single-select="false"
          :loading="loadingJobs"
        >
          <template #selection="{ item }">
            <v-chip
              v-if="item && (item.sub_class_color || item.sub_class_name)"
              small
              :color="item.sub_class_color"
              text-color="white"
              class="mr-2"
            >
              {{ item.sub_class_name }}
            </v-chip>
            <span><span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.name ? item.name : '' }} <span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span></span>
          </template>
          <template #item="{ item }">
            <v-chip
              v-if="item && (item.sub_class_color || item.sub_class_name)"
              small
              :color="item.sub_class_color"
              text-color="white"
              class="mr-2"
            >
              {{ item.sub_class_name }}
            </v-chip>
            <span><span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.name ? item.name : '' }} <span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span></span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-spacer />
      <v-col
        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin))"
        cols="auto"
        class="pb-0 pl-0 pt-1"
      >
        <v-btn
          color="teal"
          outlined
          @click="onScreensPriorityListClick()"
        >
          SCREENS PRIORITY LIST
        </v-btn>
      </v-col>
      <v-col
        cols="auto"
        class="pb-0 pl-0 pt-1"
      >
        <v-menu
          v-model="filterMenu"
          transition="scale-transition"
          offset-y
          min-width="500"
          nudge-left="50"
          :close-on-content-click="false"
        >
          <template #activator="{ on, attrs }">
            <v-btn
              color="success"
              outlined
              v-bind="attrs"
              v-on="on"
              @click="filterMenu = !filterMenu"
            >
              <v-icon
                small
                class="mr-1"
              >
                mdi-filter
              </v-icon>
              FILTERS
            </v-btn>
          </template>
          <v-card
            class="pa-8"
          >
            <v-row>
              <v-col>
                <v-row>
                  <v-col>
                    <span style="font-size: 22px !important; font-weight: bold;">Filters</span>
                  </v-col>
                  <v-col class="text-end pr-1">
                    <v-btn
                      icon
                      :style="{color: isDarkMode ? '' : '#000000'}"
                      @click="filterMenu = !filterMenu"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-menu
                      ref="menuShipDate"
                      v-model="dateMenuShipDate"
                      transition="scale-transition"
                      offset-y
                      clearable
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="filterPlannedShipDate"
                          readonly
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                          @change="$refs.menuShipDate.save(filterPlannedShipDate)"
                        >
                          <template slot="label">
                            Plan Ship Date From
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filterPlannedShipDate"
                        no-title
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="filterPlannedShipDate = null"
                        >
                          Clear
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-menu
                      ref="menuShipDateEnd"
                      v-model="dateMenuShipDateEnd"
                      transition="scale-transition"
                      offset-y
                      clearable
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="filterPlannedShipDateEnd"
                          readonly
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                          @change="$refs.menuShipDateEnd.save(filterPlannedShipDateEnd)"
                        >
                          <template slot="label">
                            Plan Ship Date To
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filterPlannedShipDateEnd"
                        no-title
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="filterPlannedShipDateEnd = null"
                        >
                          Clear
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-menu
                      ref="menuProductionCompletionDate"
                      v-model="dateMenuProductionCompletionDate"
                      transition="scale-transition"
                      offset-y
                      clearable
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="filterProductionCompletionDate"
                          readonly
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                          @change="$refs.menuProductionCompletionDate.save(filterProductionCompletionDate)"
                        >
                          <template slot="label">
                            Production Completion Date From
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filterProductionCompletionDate"
                        no-title
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="filterProductionCompletionDate = null"
                        >
                          Clear
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-menu
                      ref="menuProductionCompletionDateEnd"
                      v-model="dateMenuProductionCompletionDateEnd"
                      transition="scale-transition"
                      offset-y
                      clearable
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="filterProductionCompletionDateEnd"
                          readonly
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                          @change="$refs.menuProductionCompletionDateEnd.save(filterProductionCompletionDateEnd)"
                        >
                          <template slot="label">
                            Production Completion Date To
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filterProductionCompletionDateEnd"
                        no-title
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="filterProductionCompletionDateEnd = null"
                        >
                          Clear
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col />
                </v-row>
                <v-row>
                  <v-spacer />
                  <v-col
                    cols="auto"
                    class="pr-0"
                  >
                    <v-btn
                      color="normal"
                      @click="filterMenu = !filterMenu"
                    >
                      <span style="font-size: 14px !important;">Close</span>
                    </v-btn>
                  </v-col>
                  <v-col cols="auto">
                    <v-btn
                      color="primary"
                      @click="clearAllFilters"
                    >
                      Clear
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-menu>
      </v-col>
      <v-col
        cols="auto"
        class="pb-0 pl-0 pt-1"
      >
        <v-menu
          offset-y
          min-width="400"
          :close-on-content-click="false"
        >
          <template #activator="{ on, attrs }">
            <v-btn
              color="orange"
              outlined
              v-bind="attrs"
              v-on="on"
            >
              <v-icon
                style="font-size: 20px;"
                class="pr-1"
              >
                mdi-cog
              </v-icon> MORE OPTIONS
            </v-btn>
          </template>
          <v-card>
            <div class="d-flex flex-column ga-4 pa-6">
              <div
                class="options-item-div"
                @click="runWebhook('pdf')"
              >
                <v-icon style="color: #DC2626;">
                  mdi-file-document-outline
                </v-icon>
                <span style="color: #DC2626; font-weight: 600; font-size: 16px !important">GENERATE PDF</span>
              </div>
              <div
                class="options-item-div"
                @click="runWebhook('xls')"
              >
                <v-icon style="color: #16A34A;">
                  mdi-file-excel-outline
                </v-icon>
                <span style="color: #16A34A; font-weight: 600; font-size: 16px !important">GENERATE XLS</span>
              </div>
              <div style="border-bottom: 1px solid rgba(0,0,0,0.2);" />
              <div
                v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin))"
                class="options-item-div"
                @click="selectedItems.length === 0 ? '' : archiveAll()"
              >
                <v-icon :style="`color: ${selectedItems.length === 0 ? 'rgba(0,0,0,0.4)' : '#0D9488'};`">
                  mdi-archive-outline
                </v-icon>
                <span :style="`color: ${selectedItems.length === 0 ? 'rgba(0,0,0,0.4)' : '#0D9488'}; font-weight: 600; font-size: 16px !important`">{{ status == 1 ? 'ARCHIVE' : 'RESTORE' }}</span>
              </div>
              <div
                class="options-item-div"
                @click="selectedItems.length === 0 ? '' :openPlannedShipDateMultipleForm()"
              >
                <v-icon :style="`color: ${selectedItems.length === 0 ? 'rgba(0,0,0,0.4)' : '#0891B2'};`">
                  mdi-truck-delivery-outline
                </v-icon>
                <span :style="`color: ${selectedItems.length === 0 ? 'rgba(0,0,0,0.4)' : '#0891B2'}; font-weight: 600; font-size: 16px !important`">CHANGE PLAN SHIP DATE</span>
              </div>
            </div>
          </v-card>
        </v-menu>
      </v-col>
      <v-col
        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin))"
        cols="auto"
        class="pb-0 pl-0 pt-1"
      >
        <v-btn
          color="primary"
          outlined
          @click="open()"
        >
          <v-icon
            small
            class="mr-1"
          >
            fas fa-plus
          </v-icon>
          New Record
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        class="pa-1"
      >
        <v-card
          elevation="0"
          outlined
        >
          <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="footer"
            :items-per-page="pagination.itemsPerPage"
            :search="search"
            fixed-header
            :loading="loading"
            dense
            :height="windowHeight"
            :server-items-length="totalItems"
            @update:options="updateOptions"
          >
            <template
              v-for="h in headers"
              #[`header.${h.value}`]="{ header }"
            >
              <v-tooltip
                :key="h.value"
                top
              >
                <template #activator="{ on }">
                  <span v-on="on">{{ header.text }}</span>
                </template>
                <span>{{ header.fullText }}</span>
              </v-tooltip>
            </template>
            <template #item="{ item }">
              <tr>
                <td
                  v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate))"
                  class="pl-1 pr-1"
                >
                  <v-checkbox
                    v-model="selectedItems"
                    :disabled="status == statusIdOnHand && selectedItems.length >= 1 && !selectedItems.includes(item)"
                    :value="item"
                    class="mt-0 mb-0 pt-0"
                    hide-details
                  />
                </td>
                <td class="pl-1 pr-1">
                  <v-chip
                    small
                    :color="item && item.class ? item.class.color : 'grey'"
                    text-color="white"
                  >
                    {{ item && item.class ? item.class.name : '' }}
                  </v-chip>
                </td>
                <td class="pl-1 pr-1">
                  <v-tooltip
                    top
                    color="transparent"
                    style="opacity: 1;"
                  >
                    <template #activator="{ on }">
                      <span
                        v-if="item.is_shipping_complete == 1"
                        :style="{fontWeight: 500, color: (isDarkMode ? 'black' : '#0000000'), borderRadius: '4px', width: 'auto', height: '25px', border: 0, backgroundColor: '#C8E6C9'}"
                        class="pa-1"
                        v-on="on"
                      ><text-highlight :queries="search">{{ item.project }}</text-highlight></span>
                      <span
                        v-else-if="item.is_ready_for_shipping == 1"
                        :style="{fontWeight: 500, color: (isDarkMode ? 'black' : '#0000000'), borderRadius: '4px', width: 'auto', height: '25px', border: 0, backgroundColor: '#F8BBD0'}"
                        class="pa-1"
                        v-on="on"
                      ><text-highlight :queries="search">{{ item.project }}</text-highlight></span>

                      <span
                        v-else
                        style="font-weight: 500;"
                        v-on="on"
                      ><text-highlight :queries="search">{{ item.project }}</text-highlight></span>
                    </template>
                    <v-chip
                      v-if="item && (item.sub_class_color || item.sub_class_name)"
                      small
                      :color="item.sub_class_color"
                      text-color="white"
                    >
                      {{ item.sub_class_name }}
                    </v-chip>
                  </v-tooltip>
                </td>
                <td class="pl-1 pr-1">
                  <span><text-highlight :queries="search">{{ item.project_floor }}</text-highlight></span>
                </td>
                <td class="pl-1 pr-1">
                  <v-tooltip
                    color="black"
                    top
                  >
                    <template #activator="{ on }">
                      <span v-on="on"><text-highlight
                        :queries="search"
                        v-on="on"
                      >{{ item.wo_number }}</text-highlight></span>
                    </template>
                    <span>{{ item.created_at_po_min }}</span>
                  </v-tooltip>
                </td>
                <td
                  class="pl-1 pr-1"
                >
                  <span><text-highlight :queries="search">{{ item.screen_quantity }}</text-highlight></span>
                </td>
                <td
                  class="pl-1 pr-1"
                >
                  <v-btn
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    :ripple="false"
                    color="#FFD84D"
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_cut > 0 ? '#FFD84D' : item.is_prod_backlog == 1 ? '#4CAF50' : ''}; background-color: ${item.total_cut > 0 ? '#FFD84D' : item.is_prod_backlog == 1 ? '#4CAF50' : ''}`"
                    @click="openFinishedGoodForm(item, 1)"
                  >
                    <span
                      v-if="item.total_cut > 0"
                      style="color: #000000;"
                    >{{ item.total_cut }}</span>
                    <span
                      v-else-if="item.is_prod_backlog == 1"
                      style="color: #FFFFFF;"
                    >C</span>
                    <span
                      v-else
                      style="color: #000000;"
                    />
                  </v-btn>
                </td>

                <td class="pl-1 pr-1">
                  <v-btn
                    v-if="item.is_prod_backlog && item.total_prod_backlog >= 0"
                    elevation="0"
                    fab
                    outlined
                    tile
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_prod_backlog != 0 ? '#EF5350' : '#4CAF50'}; background-color: ${item.total_prod_backlog != 0 ? '#EF5350' : '#4CAF50'} ;`"
                    @click="openFinishedGoodForm(item, 8)"
                  >
                    <span
                      style="color: #FFFFFF;"
                    >{{ item.total_prod_backlog || item.total_prod_backlog == 0 ? item.total_prod_backlog : '' }}</span>
                  </v-btn>
                  <a
                    v-else
                  >-</a>
                </td>
                <td class="pl-1 pr-1">
                  <v-btn
                    v-if="item.is_shipping && item.total_shipping >= 0"
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_shipping != 0 ? '#EF5350' : '#4CAF50'}; background-color: ${item.total_shipping != 0 ? '#EF5350' : '#4CAF50'};`"
                    @click="openFinishedGoodForm(item, 9)"
                  >
                    <span
                      style="color: #FFFFFF;"
                    >{{ item.total_shipping || item.total_shipping == 0 ? item.total_shipping : '' }}</span>
                  </v-btn>
                  <a
                    v-else
                  >-</a>
                </td>
                <td class="pl-1 pr-1">
                  <v-btn
                    v-if="item.is_received && item.total_shipped >= 0"
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_shipped != 0 ? '#EF5350' : '#4CAF50'}; background-color: ${item.total_shipped != 0 ? '#EF5350' : '#4CAF50'};`"
                    @click="openFinishedGoodForm(item, 10)"
                  >
                    <span
                      style="color: #FFFFFF;"
                    >{{ item.total_shipped || item.total_shipped == 0 ? item.total_shipped : '' }}</span>
                  </v-btn>
                  <a
                    v-else
                  >-</a>
                </td>
                <!-- <td class="pl-1 pr-1">
                  <v-btn
                    v-if="item.total_returned > 0"
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_returned != 0 ? '#EF5350' : '#4CAF50'}; background-color: ${item.total_returned != 0 ? '#EF5350' : '#4CAF50'};`"
                    @click="openFinishedGoodForm(item, 12)"
                  >
                    <span
                      style="color: #FFFFFF;"
                    >{{ item.total_returned || item.total_returned == 0 ? item.total_returned : '' }}</span>
                  </v-btn>
                  <a
                    v-else
                  >-</a>
                </td> -->
                <td class="pl-1 pr-1">
                  <a
                    style="white-space: nowrap;"
                    @click="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdScreenAdmin) || roles.includes(userRoleIdScreenSupervisor) ? openProductionCompletionDateForm(item) : ''"
                  ><text-highlight :queries="search">{{ item.production_completion_date_short }}</text-highlight></a>
                </td>
                <td class="pl-0 pr-0">
                  <v-icon
                    v-if="item.production_completion_date_is_up == 1"
                    color="#388E3C"
                    style="font-size: 20px;"
                  >
                    mdi-arrow-up
                  </v-icon>
                  <v-icon
                    v-else-if="item.production_completion_date_is_up == 0"
                    color="#D32F2F"
                    style="font-size: 20px;"
                  >
                    mdi-arrow-down
                  </v-icon>
                </td>

                <td class="pl-1 pr-1">
                  <a
                    style="white-space: nowrap;"
                    @click="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdScreenAdmin) || roles.includes(userRoleIdScreenSupervisor) ? openPlannedShipDateForm(item) : ''"
                  ><text-highlight :queries="search">{{ item.planned_ship_date_short }}</text-highlight></a>
                </td>
                <td class="pl-0 pr-0">
                  <v-icon
                    v-if="item.ship_date_is_up == 1"
                    color="#388E3C"
                    style="font-size: 20px;"
                  >
                    mdi-arrow-up
                  </v-icon>
                  <v-icon
                    v-else-if="item.ship_date_is_up == 0"
                    color="#D32F2F"
                    style="font-size: 20px;"
                  >
                    mdi-arrow-down
                  </v-icon>
                </td>
                <td
                  class="pl-1 pr-1"
                >
                  <v-tooltip
                    v-if="item.ship_to_address"
                    top
                    color="black"
                  >
                    <template #activator="{ on }">
                      <span
                        style="white-space: nowrap; color: rgb(255, 152, 0); "
                        v-on="on"
                      >
                        <v-icon>
                          mdi-map-marker
                        </v-icon>
                      </span>
                    </template>
                    <span>{{ item.ship_to_address ? item.ship_to_address : '' }}</span>
                  </v-tooltip>
                </td>
                <td
                  class="pl-1 pr-1 text-center"
                >
                  <v-chip
                    small
                    :color="item && item.screen_status ? item.screen_status.color : 'grey'"
                    text-color="white"
                  >
                    {{ item && item.screen_status ? item.screen_status.name : '' }}
                  </v-chip>
                </td>
                <td
                  class="pl-1 pr-1 text-center"
                >
                  <v-chip
                    v-if="item.delay_reason"
                    small
                    :color="item && item.delay_reason ? item.delay_reason.color : 'black'"
                    text-color="white"
                  >
                    {{ item && item.delay_reason ? item.delay_reason.name : '' }}
                  </v-chip>
                </td>
                <td class="pl-1 pr-1">
                  <v-tooltip
                    v-if="item.last_note"
                    top
                    color="black"
                  >
                    <template #activator="{ on }">
                      <span
                        style="white-space: nowrap; color: rgb(255, 152, 0);"
                        v-on="on"
                      >
                        <v-btn
                          v-if="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdProductionSupervisor) || roles.includes(userRoleIdGlassHandler) || roles.includes(userRoleIdScreenAdmin) || roles.includes(userRoleIdScreenSupervisor)"
                          icon
                          small
                          @click="openNotes(item.id)"
                        >
                          <v-icon
                            small
                          >
                            mdi-eye
                          </v-icon>
                        </v-btn>
                        <!-- <text-highlight
                          :queries="search"
                        >{{ item.last_note_short }}</text-highlight> -->
                      </span>
                    </template>
                    <span>{{ item.last_note }}</span>
                  </v-tooltip>
                </td>

                <td
                  id="cellOverflow"
                  :class="(isDarkMode ? 'theme--dark ' : '') + 'pl-0 pr-0 text-end'"
                >
                  <v-btn
                    v-if="item.is_shipping && item.total_shipping == 0 && ((roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate)))"
                    class="ml-1 mr-3 mt-1 mb-1 elevation-0"
                    color="#0BDE79"
                    small
                    @click="toggle(item.id, item.status_id)"
                  >
                    <span style="color: white;">{{ item.status_id === statusIdInProgress ? 'DONE' : 'RESTORE' }}</span>
                  </v-btn>
                  <v-menu
                    v-if="item.status_id != statusIdOnHand && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdScreenAdmin))"
                    offset-y
                  >
                    <template #activator="{ on, attrs }">
                      <v-btn
                        class="mt-1 mb-1 mr-1"
                        elevation="0"
                        fab
                        outlined
                        x-small
                        v-bind="attrs"
                        tile
                        color="primary"
                        style="border-radius: 7px; width: 28px !important; height: 28px !important;"
                        v-on="on"
                      >
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list
                      class="pa-3"
                    >
                      <v-list-item
                        v-if="(item.status_id == statusIdInProgress || item.status_id == statusIdOnHand) && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdScreenAdmin))"
                        @click="openEdit(item)"
                      >
                        <v-list-item-title style="color: #1976d2; font-weight: 600;">
                          EDIT
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdScreenAdmin)) && (item.status_id == statusIdInProgress || item.status_id == statusIdOnHand)"
                        @click="softDelete(item.id)"
                      >
                        <v-list-item-title style="color: #ff5252; font-weight: 600;">
                          DELETE
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdProductionSupervisor) || roles.includes(userRoleIdGlassHandler) || roles.includes(userRoleIdScreenAdmin) || roles.includes(userRoleIdScreenSupervisor)"
                        @click="openNotes(item.id)"
                      >
                        <v-list-item-title style="color: #ff9800; font-weight: 600;">
                          NOTES {{ item.notes ? `(${item.notes.length})` : '' }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdScreenAdmin)) && (item.status_id == statusIdInProgress || item.status_id == statusIdOnHand)"
                        @click="toggle(item.id, item.status_id, true)"
                      >
                        <v-list-item-title style="color: purple; font-weight: 600;">
                          ARCHIVE
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-else-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdScreenAdmin))"
                        @click="toggle(item.id, item.status_id, false)"
                      >
                        <v-list-item-title style="color: purple; font-weight: 600;">
                          RESTORE
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdScreenAdmin)) && (item.status_id == statusIdInProgress || item.status_id == statusIdOnHand)"
                        @click="delay(item)"
                      >
                        <v-list-item-title style="color: #00695C; font-weight: 600;">
                          DELAY
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu
                    v-else-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdScreenAdmin))"
                    offset-y
                  >
                    <template #activator="{ on, attrs }">
                      <v-btn
                        class="mt-1 mb-1 mr-1"
                        elevation="0"
                        fab
                        outlined
                        x-small
                        v-bind="attrs"
                        tile
                        color="primary"
                        style="border-radius: 7px; width: 28px !important; height: 28px !important;"
                        v-on="on"
                      >
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list
                      class="pa-3"
                    >
                      <v-list-item
                        v-if="(item.status_id == statusIdInProgress || item.status_id == statusIdOnHand) && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdScreenAdmin))"
                        @click="openEdit(item)"
                      >
                        <v-list-item-title style="color: #1976d2; font-weight: 600;">
                          EDIT
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdScreenAdmin)) && (item.status_id == statusIdInProgress || item.status_id == statusIdOnHand)"
                        @click="softDelete(item.id)"
                      >
                        <v-list-item-title style="color: #ff5252; font-weight: 600;">
                          DELETE
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialogProdBacklogSchedule"
      max-width="300px"
    >
      <v-card v-if="selectedProdBacklogItem">
        <v-card-text class="pt-6">
          <v-text-field
            v-model="selectedProdBacklogItem.production_backlog"
            label="Production Backlog"
            hide-details
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="normal"
            class="mr-2"
            @click="dialogProdBacklogSchedule = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="updateProductionBacklog"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogShipBacklogSchedule"
      max-width="300px"
    >
      <v-card v-if="selectedShipBacklogItem">
        <v-card-text class="pt-6">
          <v-text-field
            v-model="selectedShipBacklogItem.shipping_backlog"
            label="Shipping Backlog"
            hide-details
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="normal"
            class="mr-2"
            @click="dialogShipBacklogSchedule = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="updateShipBacklog"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogProductionCompletionDate"
      max-width="350px"
    >
      <v-card v-if="selectedItem">
        <v-card-text class="pt-6">
          <v-row>
            <v-col>
              <business-date-picker
                v-model="selectedItem.production_completion_date"
                no-title
                scrollable
                :min="dayAfterFive"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="primary"
            @click="dialogProductionCompletionDate = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="updateProductionCompletionDate(selectedItem.id, selectedItem.production_completion_date, selectedItem.production_completion_time); dialogProductionCompletionDate = false"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogProductionCompletionDateMultiple"
      max-width="350px"
    >
      <v-card>
        <v-card-text class="pt-6">
          <business-date-picker
            v-model="productionCompletionDateMultiple"
            :min="dayAfterFive"
            no-title
            scrollable
          >
            <v-spacer />
            <v-btn
              text
              color="primary"
              @click="dialogProductionCompletionDateMultiple = false"
            >
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="updateProductionCompletionDateMultiple(); dialogProductionCompletionDateMultiple = false"
            >
              Apply
            </v-btn>
          </business-date-picker>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogPlannedDate"
      max-width="350px"
    >
      <v-card v-if="selectedItem">
        <v-card-text class="pt-6">
          <v-row>
            <v-col>
              <business-date-picker
                v-model="selectedItem.planned_ship_date"
                no-title
                scrollable
                :min="getMinDate()"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="primary"
            @click="dialogPlannedDate = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="updatePlannedShipDate(selectedItem.id, selectedItem.planned_ship_date, selectedItem.planned_ship_time); dialogPlannedDate = false"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogPlannedShipDateMultiple"
      max-width="500px"
      min-width="500px"
    >
      <v-card style="min-width: 500px;">
        <v-card-title>
          Select Job Location to move to Current
        </v-card-title>
        <v-card-text>
          <v-form ref="formJob">
            <v-autocomplete
              v-model="selectedLocationId"
              :items="locations"
              item-text="name"
              item-value="id"
              :rules="[(v) => !!v || 'Job Location is required']"
              clearable
              class="mb-3"
            >
              <template slot="label">
                Job Location<RedAsterisk />
              </template>
            </v-autocomplete>
          </v-form>
          <business-date-picker
            v-model="plannedShipDateMultiple"
            no-title
            scrollable
            :min="getMinDate(true)"
            :allowed-dates="allowedDates"
            width="100%"
          >
            <v-spacer />
            <v-btn
              text
              color="primary"
              @click="dialogPlannedShipDateMultiple = false"
            >
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="updatePlannedShipDateMultiple();"
            >
              Apply
            </v-btn>
          </business-date-picker>
        </v-card-text>
      </v-card>
    </v-dialog>
    <screen-schedule-form
      ref="screenForm"
      @success="get()"
    />
    <screen-schedule-note-form
      ref="noteForm"
      @success="get()"
    />
    <screen-schedule-history-form
      ref="historyForm"
      @success="get()"
    />

    <screen-schedule-finished-good-form
      ref="finishedGoodForm"
    />

    <screen-schedule-finished-good-grouped-form
      ref="finishedGoodGroupedForm"
    />

    <bill-of-lading-returned-windows-form
      ref="billOfLadingReturnedWindowsForm"
    />

    <screen-schedule-delay-reason-form
      ref="delayReasonForm"
      @success="get()"
    />
    <confirm-form ref="confirmForm" />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ScreenScheduleForm from '@/components/forms/screenSchedules/ScreenScheduleForm';
import ScreenScheduleNoteForm from '@/components/forms/screenSchedules/ScreenScheduleNoteForm';
import ScreenScheduleHistoryForm from '@/components/forms/screenSchedules/ScreenScheduleHistoryForm';
import ScreenScheduleFinishedGoodForm from '@/components/forms/screenSchedules/ScreenScheduleFinishedGoodForm';
import * as FormatHelpers from '@/helpers/FormatHelpers';
import { saveAs } from 'file-saver';
import ScreenScheduleFinishedGoodGroupedForm from '@/components/forms/screenSchedules/ScreenScheduleFinishedGoodGroupedForm';
import BillOfLadingReturnedWindowsForm from '@/components/forms/billOfLadings/BillOfLadingReturnedWindowsForm.vue';
import ScreenScheduleDelayReasonForm from '@/components/forms/screenSchedules/ScreenScheduleDelayReasonForm.vue';
import BusinessDatePicker from '@/components/elements/BusinessDatePicker.vue';

export default {
  components: {
    ScreenScheduleForm,
    ScreenScheduleNoteForm,
    ScreenScheduleHistoryForm,
    ScreenScheduleFinishedGoodForm,
    ScreenScheduleFinishedGoodGroupedForm,
    BillOfLadingReturnedWindowsForm,
    ScreenScheduleDelayReasonForm,
    BusinessDatePicker,
  },
  props: {

  },
  data: () => ({
    items: [],
    totalItems: 0,
    allItems: [],
    loading: false,
    filterJob: null,
    filterPo: null,
    filterStage: null,
    filterGlassReqBy: null,
    filterPlannedShipDate: null,
    filterPlannedShipDateEnd: null,
    filterProductionCompletionDate: null,
    filterProductionCompletionDateEnd: null,
    filterLocationId: null,
    filterJobSubClass: null,
    filterRecordType: null,
    dateMenu: false,
    inventoryClassId: null,
    jobs: [],
    poNumbers: [],
    stages: [{ name: 'Material', id: 1, code: 'M' }, { name: 'Cut', id: 2, code: 'C' }, { name: 'Assembled', id: 3, code: 'A' }, { name: 'Spandrel', id: 4, code: 'S' }, { name: 'Panels', id: 5, code: 'P' }, { name: 'T&B', id: 6, code: 'T' }, { name: 'Glazed', id: 7, code: 'G' }],
    footer: {
      'items-per-page-options': [20, 50, 100, 500, 1000],
    },
    statusIdInProgress: 1,
    statusIdComleted: 2,
    statusIdOnHand: 3,
    noteStatusIdShort: 2,
    noteStatusIdZero: 3,
    materialAvailableId: 1,
    cutId: 2,
    assembleId: 3,
    spandrelId: 4,
    panelsId: 5,
    tAndBId: 6,
    glazedId: 7,
    ppStartedId: 8,
    ppFinishedId: 9,
    topSpaceHeight: 200,
    windowHeight: 1000,
    windowWidth: 1000,
    status: null,
    pagination: {
      itemsPerPage: 500,
      page: 1,
    },
    sort: {
      order_by_first: 'production_completion_date',
      direction_sort: true,
    },
    filterMenu: false,
    dateMenuRequiredBy: false,
    dateMenuShipDate: false,
    dateMenuShipDateEnd: false,
    dateMenuProductionCompletionDate: false,
    dateMenuProductionCompletionDateEnd: false,
    roles: [],
    locations: [],
    userRoleIdAdmin: 3,
    userRoleIdAssociate: 6,
    userRoleIdGlassHandler: 13,
    userRoleIdProductionSupervisor: 18,
    userRoleIdSplanderPaintSupervisor: 21,
    userRoleIdProductionAdmin: 22,
    userRoleIdScreenSupervisor: 39,
    userRoleIdScreenAdmin: 40,
    recordTypes: [{ id: 1, name: 'Default Records' }, { id: 2, name: 'Manual Records' }],
    selectedItems: [],
    tabs: [],
    locationTabFilter: null,
    selectedTab: null,
    selectedProdBacklogItem: null,
    dialogProdBacklogSchedule: false,
    dialogShipBacklogSchedule: false,
    selectedShipBacklogItem: null,
    dialogSPGlassNote: false,
    dialogSUGlassNote: false,
    dialogShipDate: false,
    dialogPlannedDate: false,
    dialogProductionCompletionDate: false,
    selectedItem: null,
    noteStatuses: [],
    isShowBreakdown: false,
    typeIdSUItems: 1,
    typeIdSPItems: 2,
    loadingJobs: false,
    loadingPo: false,
    dialogGlassRequiredByDateMultiple: false,
    dialogPlannedShipDateMultiple: false,
    dialogProductionCompletionDateMultiple: false,
    productionCompletionDateMultiple: null,
    glassRequiredByDateMultiple: null,
    plannedShipDateMultiple: null,
    isGlassRelated: false,
    windowAccuracy: null,
    today: new Date().toISOString().substr(0, 10),
    dayAfterTomorrow: new Date(Date.now() + 2 * 86400000).toISOString().substr(0, 10),
    dayAfterFive: new Date(Date.now() + 6 * 86400000).toISOString().substr(0, 10),
    dayAfterSix: new Date(Date.now() + 7 * 86400000).toISOString().substr(0, 10),
    selectedLocationId: null,
  }),
  computed: {
    ...mapState({
      search: (state) => state.search,
      user: (state) => state.user,
      isDarkMode: 'isDarkMode',
      screenScheduleState: (state) => state.screenScheduleState,
    }),
    ...mapGetters([

    ]),
    headers() {
      const headers = [];
      const isAdmin = this.roles.includes(this.userRoleIdAdmin)
                  || this.roles.includes(this.userRoleIdProductionAdmin)
                  || this.roles.includes(this.userRoleIdAssociate);

      if (isAdmin) {
        headers.push({
          text: '', fullText: '', value: 'checkbox', class: 'pl-1 pr-1', width: '3%', sortable: false,
        });
      }

      headers.push({
        text: 'Class', fullText: 'Class', value: 'class', class: 'pl-1 pr-1', width: '5%',
      });
      headers.push({
        text: 'Project', fullText: 'Project', value: 'project', class: 'pl-1 pr-1', width: '11%',
      });
      headers.push({
        text: 'Floor', fullText: 'Floor', value: 'project_floor', class: 'pl-1 pr-1', width: '6%',
      });
      headers.push({
        text: 'WO#', fullText: 'WO#', value: 'wo_number', class: 'pl-1 pr-1', width: '6%',
      });
      headers.push({
        text: 'Screens', fullText: 'Screens', value: 'screen_quantity', class: 'pl-1 pr-1', width: '5%', sortable: false,
      });
      headers.push({
        text: 'Cut', fullText: 'Cut?', value: 'is_cut', class: 'pl-1 pr-1', width: '5%', sortable: false,
      });
      headers.push({
        text: 'Prod. Back', fullText: 'Production Backlog', value: 'production_backlog', class: 'pl-1 pr-1', width: '5%', sortable: false,
      });
      headers.push({
        text: 'Ship. Back', fullText: 'Shipping Backlog', value: 'shipping_backlog', class: 'pl-1 pr-1', width: '5%', sortable: false,
      });
      headers.push({
        text: 'Rec. Back', fullText: 'Received Backlog', value: 'received_backlog', class: 'pl-1 pr-1', width: '5%', sortable: false,
      });
      headers.push({
        text: 'Prod. Comp. Date', fullText: 'Production Completion Date', value: 'production_completion_date', class: 'pl-1 pr-0', width: '7%',
      });
      headers.push({
        text: '', fullText: '', value: 'arrow', class: 'pl-0 pr-0', width: '1.5%', sortable: false,
      });
      headers.push({
        text: 'Plan. Ship Date', fullText: 'Planned Ship Date', value: 'planned_ship_date', class: 'pl-1 pr-0', width: '7%',
      });
      headers.push({
        text: '', fullText: '', value: 'arrow', class: 'pl-0 pr-0', width: '1.5%', sortable: false,
      });
      headers.push({
        text: 'Shipped To', fullText: 'Shipped To', value: 'shipped_to', class: 'pl-1 pr-1', width: '6%',
      });
      headers.push({
        text: 'Status', fullText: 'Status', value: 'status', class: 'pl-1 pr-1', width: '6%', align: 'center',
      });
      headers.push({
        text: 'Delay Reason', fullText: 'Delay Reason', value: 'delay_reason', class: 'pl-1 pr-1', width: '10%', sortable: false, align: 'center',
      });
      headers.push({
        text: 'Note', fullText: 'Note', value: 'last_note', class: 'pl-1 pr-1', width: '10%', sortable: false,
      });
      headers.push({
        text: '', value: 'actions', align: 'end', class: 'pl-0 pr-0', width: '3%', sortable: false,
      });

      return headers;
    },
  },
  watch: {
    inventoryClassId() {
      this.get();
      this.getWindowAccuracy();
    },
    filterJob(value) {
      this.storeState('job_id', value);
      this.get();
    },
    filterPo(value) {
      this.storeState('po_number', value);
      this.get();
    },
    filterStage(value) {
      this.storeState('stage', value);
      this.get();
    },
    filterGlassReqBy(value) {
      this.storeState('glass_required_by', value);
      this.get();
    },
    filterPlannedShipDate(value) {
      this.storeState('planned_ship_date', value);
      this.get();
    },
    filterPlannedShipDateEnd(value) {
      this.storeState('planned_ship_date_end', value);
      this.get();
    },
    filterProductionCompletionDate(value) {
      this.storeState('production_completion_date', value);
      this.get();
    },
    filterProductionCompletionDateEnd(value) {
      this.storeState('production_completion_date_end', value);
      this.get();
    },
    filterLocationId() {
      this.get();
    },
    filterRecordType(value) {
      this.storeState('record_type', value);
      this.get();
    },
    filterJobSubClass() {
      this.get();
    },
    status() {
      this.get();
    },
    pagination() {
      this.get();
    },
    $route(to) {
      this.status = to.params.status;
      // if (this.status === this.statusIdOnHand) {
      //   this.pagination.sortBy = ['po_number'];
      // } else {
      //   this.pagination.sortBy = ['planned_ship_date'];
      // }
    },
    search() {
      this.get();
    },
    locationTabFilter() {
      if (this.locationTabFilter === 0) {
        this.filterLocationId = null;
        this.get();
        return;
      }
      const location = this.tabLocations[this.locationTabFilter];
      if (!location) return;
      this.filterLocationId = location.id;
      this.get();
    },
    isShowBreakdown(value) {
      this.storeState('isShowBreakdown', value);
    },

    isGlassRelated(value) {
      this.storeState('isGlassRelated', value);
      this.get();
    },
  },
  created() {
    this.status = this.$route.params.status;
    if (!this.status) return;
    if (this.screenScheduleState) {
      if (this.screenScheduleState.pagination) { this.pagination = this.screenScheduleState.pagination; }
      if (this.screenScheduleState.job_id) { this.filterJob = this.screenScheduleState.job_id; }
      if (this.screenScheduleState.po_number) { this.filterPo = this.screenScheduleState.po_number; }
      if (this.screenScheduleState.stage) { this.filterStage = this.screenScheduleState.stage; }
      if (this.screenScheduleState.glass_required_by) { this.filterGlassReqBy = this.screenScheduleState.glass_required_by; }
      if (this.screenScheduleState.planned_ship_date) { this.filterPlannedShipDate = this.screenScheduleState.planned_ship_date; }
      if (this.screenScheduleState.planned_ship_date_end) { this.filterPlannedShipDateEnd = this.screenScheduleState.planned_ship_date_end; }
      if (this.screenScheduleState.production_completion_date) { this.filterProductionCompletionDate = this.screenScheduleState.production_completion_date; }
      if (this.screenScheduleState.production_completion_date_end) { this.filterProductionCompletionDateEnd = this.screenScheduleState.production_completion_date_end; }
      if (this.screenScheduleState.record_type) { this.filterRecordType = this.screenScheduleState.record_type; }
      if (this.screenScheduleState.selectedTab) { this.tabChange(this.screenScheduleState.selectedTab); }
      if (this.screenScheduleState.isShowBreakdown !== null) { this.isShowBreakdown = this.screenScheduleState.isShowBreakdown; }
      if (this.screenScheduleState.isGlassRelated !== null) { this.isGlassRelated = this.screenScheduleState.isGlassRelated; }
    }
    this.roles = this.user.roles.map((x) => x.id);
    this.windowHeight = window.innerHeight - this.topSpaceHeight;
    this.windowWidth = window.innerWidth;
    this.getLocations();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
    const tableWrapper = document.querySelector('.v-data-table__wrapper');
    tableWrapper.addEventListener('scroll', this.checkScroll);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    const tableWrapper = document.querySelector('.v-data-table__wrapper');
    tableWrapper.removeEventListener('scroll', this.checkScroll);
  },
  methods: {
    init() {
      this.getJobs();
      this.getGlassPos();
      this.getNoteStatuses();
    },

    storeState(property, value) {
      const state = this.screenScheduleState;
      state[property] = value;
      this.$store.commit('storeScreenScheduleState', state);
    },

    async get() {
      if (this.inventoryClassId === null) return;
      this.loading = true;
      this.items = [];
      this.totalItems = 0;
      const submitModel = {
        filters: {
          status_id: this.status,
          inventory_class_id: this.inventoryClassId,
          stage: this.filterStage,
          job_id: this.filterJob,
          date: this.filterDate,
          po_number: this.filterPo,
          glass_required_by: this.filterGlassReqBy,
          start_date: this.filterPlannedShipDate,
          end_date: this.filterPlannedShipDateEnd,
          start_date_production_completion: this.filterProductionCompletionDate,
          end_date_production_completion: this.filterProductionCompletionDateEnd,
          location_id: this.filterLocationId,
          record_type: this.filterRecordType,
          job_sub_class_id: this.filterJobSubClass,
          is_glass_related: this.isGlassRelated === true ? 1 : 0,
        },
        pagination: this.pagination,
        search: this.search,
        sort: this.sort,
      };
      const res = await this.$api.screenSchedule.readData(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      this.loading = false;
      this.init();
      if (!res || !res.data || res.data.length === 0) {
        this.items = [];
        this.allItems = [];
        this.totalItems = 0;
        return;
      }
      this.selectedItems = [];
      this.allItems = res.data;
      this.items = res.data.slice(0, 100);
      this.totalItems = res.total;
    },

    async getJobs() {
      this.loadingJobs = true;
      const submitModel = {
        filters: { inventory_class_id: this.inventoryClassId, is_manual: 0 },
      };
      const res = await this.$api.job.readDDL(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) {
        this.loadingJobs = false;
        return;
      }
      this.jobs = res;
      this.loadingJobs = false;
    },
    async getGlassPos() {
      this.loadingPo = true;
      const res = await this.$api.glass.get(`po-numbers/${this.inventoryClassId}/${null}`);
      if (!res) {
        this.poNumbers = [];
        this.loadingPo = false;
        return;
      }
      this.poNumbers.push('N/A');
      this.poNumbers.push(...res);
      this.loadingPo = false;
    },

    async getLocations() {
      this.locations = await this.$api.location.getList();

      const locationId99Vinyl = 8;
      this.locations = this.locations.filter((x) => x.id === locationId99Vinyl);
      this.tabs.push(...this.locations);
      this.tabs.forEach((x) => {
        // eslint-disable-next-line no-param-reassign
        x.type = 'location';
      });
    },

    async getNoteStatuses() {
      this.noteStatuses = await this.$api.screenScheduleNoteStatus.get();
    },

    async getWindowAccuracy() {
      const submitModel = {
        inventory_class_id: this.inventoryClassId,
        location_id: this.filterLocationId,
        job_sub_class_id: this.filterJobSubClass,
      };
      this.windowAccuracy = await this.$api.screenSchedule.store(submitModel, 'window-accuracy');
    },

    openFinishedGoodForm(item, statusId) {
      if (!this.roles.includes(this.userRoleIdAdmin) && !this.roles.includes(this.userRoleIdProductionAdmin) && !this.roles.includes(this.userRoleIdAssociate) && !this.roles.includes(this.userRoleIdSplanderPaintSupervisor) && !this.roles.includes(this.userRoleIdProductionSupervisor) && !this.roles.includes(this.userRoleIdScreenAdmin) && !this.roles.includes(this.userRoleIdScreenSupervisor)) return;
      this.$refs.finishedGoodForm.open(item, statusId);
    },

    async toggle(id, statusId, isAchive = false) {
      let title = '';
      if (isAchive) {
        title = 'ARCHIVE';
      } else if (statusId === this.statusIdInProgress) {
        title = 'COMPLETE';
      } else {
        title = 'RESTORE';
      }
      const confirm = await this.$refs.confirmForm.open({
        title: `Are you sure that you want to ${title} this record?`,
      });
      if (!confirm) return;
      const res = await this.$api.screenSchedule.get(`toggle/${id}/${statusId}`);
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    open() {
      this.$refs.screenForm.open();
    },

    openManual() {
      this.$refs.manualForm.open();
    },

    openEdit(item) {
      this.$refs.screenForm.open(item.id);
    },

    openNotes(id) {
      this.$refs.noteForm.open(id);
    },

    openHistory(id) {
      this.$refs.historyForm.open(id);
    },

    async softDelete(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this record?',
      });
      if (!confirm) return;
      this.$bus.$emit('loading');
      const res = await this.$api.screenSchedule.delete(id);
      this.$bus.$emit('loading');
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    onResize() {
      this.windowHeight = window.innerHeight - this.topSpaceHeight;
      this.windowWidth = window.innerWidth;
    },

    allowedDates(val) {
      const day = new Date(val).getDay();
      return day !== 6;
    },

    clearAllFilters() {
      this.filterJob = null;
      this.filterPo = null;
      this.filterStage = null;
      this.filterGlassReqBy = null;
      this.filterPlannedShipDate = null;
      this.filterPlannedShipDateEnd = null;
      this.filterLocationId = null;
      this.filterRecordType = null;
      this.filterProductionCompletionDate = null;
      this.filterProductionCompletionDateEnd = null;
    },

    async runWebhook(documentType) {
      if (this.inventoryClassId === null) {
        this.$bus.$emit('showError', 'Please select an inventory class');
        return;
      }
      this.$bus.$emit('loading');
      const MODULE_PRODUCTION_SCHEDULE_ID = 20;
      let status = 'Current';
      if (this.status === 2) {
        status = 'Archived';
      }
      const submitModel = {
        status,
        inventory_class_id: this.inventoryClassId,
        module_id: MODULE_PRODUCTION_SCHEDULE_ID,
        location_id: this.filterLocationId ? this.filterLocationId : 0,
        sub_class: this.filterJobSubClass ? this.filterJobSubClass : 0,
        is_show_stages: 'Yes',
        is_show_glass_related: this.isGlassRelated === true ? 'Yes' : 'No',
      };
      const res = await this.$api.webhook.store(submitModel, 'run');
      if (!res) return;
      const pdf = await this.$api.report.download(res.id, documentType);
      if (!pdf) {
        this.$bus.$emit('showError', 'Report Failed');
        return;
      }
      const now = FormatHelpers.getFileTimestamp();
      const fileName = `Report_${res.report_title}_${now}`;
      const file = new Blob([pdf], {
        type: documentType === 'pdf' ? 'application/pdf' : 'application/vnd.ms-excel',
      });
      if (documentType === 'pdf') {
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }
      saveAs(file, fileName);
      this.$bus.$emit('loading');
    },

    openPlannedShipDateForm(item) {
      this.selectedItem = item;
      this.dialogPlannedDate = true;
    },

    openPlannedShipDateMultipleForm() {
      this.plannedShipDateMultiple = null;
      this.dialogPlannedShipDateMultiple = true;
    },

    async updatePlannedShipDate(id, plannedShipDate, plannedShipTime) {
      const res = await this.$api.screenSchedule.update({ id, planned_ship_date: plannedShipDate, planned_ship_time: plannedShipTime }, 'planned-ship-date');
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }

      // eslint-disable-next-line eqeqeq
      if (this.status == this.statusIdOnHand) {
        const date = this.subtractWeekdays(new Date(plannedShipDate), 1);

        const resProd = this.$api.screenSchedule.update(
          { id, production_completion_date: date.toISOString().slice(0, 10) },
          'production-completion-date',
        );

        if (!resProd) {
          this.$bus.$emit('showError');
          return;
        }

        const dateGlass = this.subtractWeekdays(new Date(plannedShipDate), 3);

        const resGlass = this.$api.screenSchedule.update(
          { id, glass_required_by: dateGlass.toISOString().slice(0, 10) },
          'glass-required-by-date',
        );

        if (!resGlass) {
          this.$bus.$emit('showError');
          return;
        }
      }

      this.$bus.$emit('showSuccess');
      this.get();
    },

    async updatePlannedShipDateMultiple() {
      const valid = await this.$refs.formJob.validate();
      if (!valid) return;
      this.$bus.$emit('loading');
      const items = [];
      this.selectedItems.forEach((x) => {
        items.push(this.$api.screenSchedule.update({ id: x.id, planned_ship_date: this.plannedShipDateMultiple, location_id: this.selectedLocationId }, 'planned-ship-date'));
      });
      const itemsRes = await Promise.all(items);
      this.$bus.$emit('loading');
      if (itemsRes.includes(false)) {
        this.$bus.$emit('showError');
        return;
      }

      // eslint-disable-next-line eqeqeq
      if (this.status == this.statusIdOnHand) {
        const dateProduction = this.subtractWeekdays(new Date(this.plannedShipDateMultiple), 1);

        const productions = [];
        this.selectedItems.forEach((x) => {
          productions.push(
            this.$api.screenSchedule.update(
              { id: x.id, production_completion_date: dateProduction.toISOString().slice(0, 10) },
              'production-completion-date',
            ),
          );
        });

        const productionsRes = await Promise.all(productions);

        if (productionsRes.includes(false)) {
          this.$bus.$emit('showError');
          return;
        }

        const dateGlass = this.subtractWeekdays(new Date(this.plannedShipDateMultiple), 3);

        const glassItems = [];
        this.selectedItems.forEach((x) => {
          glassItems.push(
            this.$api.screenSchedule.update(
              { id: x.id, glass_required_by: dateGlass.toISOString().slice(0, 10) },
              'glass-required-by-date',
            ),
          );
        });

        const glassItemsRes = await Promise.all(glassItems);

        if (glassItemsRes.includes(false)) {
          this.$bus.$emit('showError');
          return;
        }
      }

      this.$bus.$emit('showSuccess');
      this.dialogPlannedShipDateMultiple = false;
      this.get();
    },

    openProductionCompletionDateForm(item) {
      this.selectedItem = item;
      this.dialogProductionCompletionDate = true;
    },

    openProductionCompletionDateMultipleForm() {
      this.productionCompletionDateMultiple = null;
      this.dialogProductionCompletionDateMultiple = true;
    },

    async updateProductionCompletionDate(id, productionCompletionDate, productionCompletionTime) {
      const res = await this.$api.screenSchedule.update({ id, production_completion_date: productionCompletionDate, production_completion_time: productionCompletionTime }, 'production-completion-date');
      if (!res) return;
      this.$bus.$emit('showSuccess');
      this.get();
    },

    async updateProductionCompletionDateMultiple() {
      this.$bus.$emit('loading');
      const items = [];
      this.selectedItems.forEach((x) => {
        items.push(this.$api.screenSchedule.update({ id: x.id, production_completion_date: this.productionCompletionDateMultiple }, 'production-completion-date'));
      });
      const itemsRes = await Promise.all(items);
      this.$bus.$emit('loading');
      if (itemsRes.includes(false)) {
        this.$bus.$emit('showError');
        return;
      }

      const date = this.subtractWeekdays(new Date(this.productionCompletionDateMultiple), 2);

      const glassItems = [];
      this.selectedItems.forEach((x) => {
        glassItems.push(this.$api.screenSchedule.update({ id: x.id, glass_required_by: date.toISOString().slice(0, 10) }, 'glass-required-by-date'));
      });

      const glassItemsRes = await Promise.all(glassItems);

      if (glassItemsRes.includes(false)) {
        this.$bus.$emit('showError');
        return;
      }

      this.$bus.$emit('showSuccess');
      this.get();
    },

    async updateProductionBacklog() {
      if (!this.selectedProdBacklogItem) return;
      this.selectedProdBacklogItem.production_backlog = this.selectedProdBacklogItem.production_backlog || this.selectedProdBacklogItem.production_backlog === 0 ? this.selectedProdBacklogItem.production_backlog : null;
      const res = await this.$api.screenSchedule.update({ id: this.selectedProdBacklogItem.id, production_backlog: this.selectedProdBacklogItem.production_backlog }, 'production-backlog');
      if (!res) return;
      this.get();
      this.dialogProdBacklogSchedule = false;
    },

    async updateShipBacklog() {
      if (!this.selectedShipBacklogItem) return;
      this.selectedShipBacklogItem.shipping_backlog = this.selectedShipBacklogItem.shipping_backlog || this.selectedShipBacklogItem.shipping_backlog === 0 ? this.selectedShipBacklogItem.shipping_backlog : null;
      const res = await this.$api.screenSchedule.update({ id: this.selectedShipBacklogItem.id, shipping_backlog: this.selectedShipBacklogItem.shipping_backlog }, 'shipping-backlog');
      if (!res) return;
      this.get();
      this.dialogShipBacklogSchedule = false;
    },

    subtractWeekdays(date, days) {
      const result = new Date(date);
      let remaining = days;

      while (remaining > 0) {
        result.setDate(result.getDate() - 1);
        const day = result.getDay();
        if (day !== 5 && day !== 6) {
          // eslint-disable-next-line no-plusplus
          remaining--;
        }
      }

      return result;
    },

    addWeekdays(date, days) {
      const result = new Date(date);
      let remaining = days;

      while (remaining > 0) {
        result.setDate(result.getDate() + 1);
        const day = result.getDay();
        if (day !== 5 && day !== 6) {
          // eslint-disable-next-line no-plusplus
          remaining--;
        }
      }

      return result;
    },

    async archiveAll() {
      const confirm = await this.$refs.confirmForm.open({
        // eslint-disable-next-line eqeqeq
        title: `Are you sure that you want to ${this.status == 1 ? 'ARCHIVE' : 'RESTORE'} all selected records?`,
      });
      if (!confirm) return;
      const requests = [];
      this.selectedItems.forEach((x) => {
        requests.push(this.$api.screenSchedule.get(`toggle/${x.id}/${x.status_id}`));
      });

      const res = await Promise.all(requests);
      if (res.includes(false)) {
        this.$bus.$emit('loading');
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    tabChange(item) {
      if (this.selectedTab === item) {
        this.selectedTab = null;
        this.filterJobSubClass = null;
        this.filterLocationId = null;
        this.get();
        this.getWindowAccuracy();
        this.storeState('selectedTab', null);
        return;
      }
      this.selectedTab = item;
      if (item.type === 'sub-class') {
        this.filterJobSubClass = item.id;
        this.filterLocationId = null;
      } else if (item.type === 'location') {
        this.filterLocationId = item.id;
        // const jobSubClass4800Windows = 1;
        // const tab300Chrislea = 2;
        // if (item.id === tab300Chrislea) {
        //   this.filterJobSubClass = jobSubClass4800Windows;
        // } else { this.filterJobSubClass = null; }
      }
      this.storeState('selectedTab', item);
      this.get();
      this.getWindowAccuracy();
    },

    openMenuProdBacklog(id) {
      const index = this.items.findIndex((item) => item.id === id);
      if (index === -1) return;
      this.selectedProdBacklogItem = this.items[index];
      this.dialogProdBacklogSchedule = true;
    },

    openMenuShipBacklog(id) {
      const index = this.items.findIndex((item) => item.id === id);
      if (index === -1) return;
      this.selectedShipBacklogItem = this.items[index];
      this.dialogShipBacklogSchedule = true;
    },

    openFinishedGoods() {
      this.$refs.finishedGoodGroupedForm.open();
    },

    async sendEmailPdf() {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to send an email containing the latest Production Schedule reports?',
      });
      if (!confirm) return;
      this.$bus.$emit('loading');
      const res = await this.$api.screenSchedule.get('send-email-pdf');
      this.$bus.$emit('loading');
      if (res) {
        this.$bus.$emit('showSuccess');
      } else {
        this.$bus.$emit('showError');
      }
    },

    checkScroll(event) {
      const bottomOfTable = (event.target.scrollHeight < event.target.scrollTop + event.target.clientHeight + 5 && event.target.scrollHeight > event.target.scrollTop + event.target.clientHeight - 5) || event.target.scrollHeight === event.target.scrollTop + event.target.clientHeight;
      if (bottomOfTable) {
        this.items = this.allItems.slice(0, this.items.length + 100);
      }
    },

    openReturnedWindows() {
      this.$refs.billOfLadingReturnedWindowsForm.open();
    },

    isJobFinished(item) {
      if (item.is_shipping === 1) {
        return true;
      }
      return false;
    },

    isJobShipped(item) {
      if (item.is_received === 1) {
        return true;
      }
      return false;
    },

    formatLocation(location) {
      const [num, word] = location.trim().split(' ');
      return `${num} ${word.slice(0, 2)}`;
    },

    delay(item) {
      this.$refs.delayReasonForm.open(item);
    },

    updateOptions(newOptions) {
      this.pagination = newOptions;
      this.sort = {
        order_by_first: newOptions.sortBy[0],
        direction_sort: newOptions.sortDesc[0],
      };
      this.storeState('pagination', newOptions);
    },

    getMinDate(multiple = false) {
      // eslint-disable-next-line eqeqeq
      if (this.status != this.statusIdOnHand) return this.today;

      let item = null;

      if (multiple) {
        if (!this.selectedItems || this.selectedItems.length !== 1) return this.dayAfterSix;
        // eslint-disable-next-line prefer-destructuring
        item = this.selectedItems[0];
      } else {
        if (!this.selectedItem) return this.dayAfterSix;
        item = this.selectedItem;
      }

      if (!item.job) return this.dayAfterSix;
      const subclassIdCornerPost = 2;
      if (item.job.sub_class_id === subclassIdCornerPost || item.job.reference.includes('BS')) {
        return this.today;
      }
      return this.dayAfterSix;
    },

    async onScreensPriorityListClick() {
      this.$bus.$emit('showError', 'Screens Priority List will be available soon.');
      return;
    },
  },
};
</script>

<style scoped>

#cellOverflow {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  min-width: 120px  !important;
  border-left: 1px solid #E0E0E0;
  background-color: #FAFAFA;

}

#cellOverflow.theme--dark {
  background-color: #323232;
}

span
{
  font-size: 12px !important;
}
::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  background-color: #323232;
}

::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th > span {
  color: #FFFFFF;
}

::v-deep .theme--light.v-divider {
    border-color: rgba(0,0,0,0.4) !important;
    border: 1px solid rgba(0,0,0,0.4) !important;
}

:v-deep .v-btn__content
{
  color: white !important;
}

.box
{
  border-radius: 4px;
   width: 25px;
    height: 25px;
}

.empty-box
{
  border: 1.5px solid #FFD84D;
  background-color: #FFFFFF;
}

.red-box
{
  border: 1.5px solid #F44336;
  background-color: #F44336;
}

.yellow-box
{
  border: 1.5px solid #FFD84D;
  background-color: #FFD84D;
}

.green-box
{
  border: 1.5px solid #4CAF50;
  background-color: #4CAF50;
}

.options-item-div
{
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
